export const findExactRoute = (path, routes) =>
  Object.values(routes).find((route) => route.path === path);
